import {setCacheNameDetails as workbox_core_setCacheNameDetails} from 'C:/Users/Student/Documents/vue_workshop/nodejs_eomp/JayMar-Climbing/node_modules/workbox-core/setCacheNameDetails.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from 'C:/Users/Student/Documents/vue_workshop/nodejs_eomp/JayMar-Climbing/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */





workbox_core_setCacheNameDetails({prefix: "front_end"});


self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/css/about.a14f29b0.css",
    "revision": null
  },
  {
    "url": "/css/app.a4961928.css",
    "revision": null
  },
  {
    "url": "/css/chunk-vendors.0d3d86ab.css",
    "revision": null
  },
  {
    "url": "/index.html",
    "revision": "78976e89eb4d63d3e0e237ec51a156ed"
  },
  {
    "url": "/js/about.0f7bfee2.js",
    "revision": null
  },
  {
    "url": "/js/app.617bb5a1.js",
    "revision": null
  },
  {
    "url": "/js/chunk-vendors.203744de.js",
    "revision": null
  },
  {
    "url": "/manifest.json",
    "revision": "bbee1403b84e48c5054e1ae856e65b62"
  },
  {
    "url": "/robots.txt",
    "revision": "735ab4f94fbcd57074377afca324c813"
  }
], {});








